import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { Radio } from '@tcc/crate';
import { getMessage } from 'util/locale';
import ApplicationProtectionDropdown from './ApplicationProtectionDropdown';

const inputsClassString = classNames({
  'crop-protection-input-half-width': false,
  'crop-protection-input-full-width': false
});

function calcClasses(type, toggled) {
  if (type === toggled || false) {
    return inputsClassString;
  }
  return inputsClassString + ' crop-protection-hidden';
}

const ApplicationProtection = ({
  chemType,
  onSelectApplicationType,
  onSetApplication,
  products,
  selectedProduct,
  toggled
}) => {
  return (
    <React.Fragment className={calcClasses(`application-${chemType}`)}>
      <Radio
        checked={toggled}
        className="crop-protection-radio"
        label={getMessage(`label-text__product-${chemType}`)}
        onClick={() => onSelectApplicationType(chemType)}
        testId={`${`application-${chemType}`}`}
      />
      <ApplicationProtectionDropdown
        disabled={!toggled}
        onSetValue={onSetApplication}
        products={products}
        selectedProduct={selectedProduct}
        substanceTypeUuid={chemType}
      />
    </React.Fragment>
  );
};

ApplicationProtection.propTypes = {
  chemType: propTypes.string,
  onSelectApplicationType: propTypes.func,
  onSetApplication: propTypes.func,
  products: propTypes.array,
  selectedProduct: propTypes.object,
  toggled: propTypes.bool
};

export default ApplicationProtection;